import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetExportRiskVehicleContract } from "../../../api/contract/service"
import { callExportRiskVehicleContract } from "../../../api/export"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import SmartTable from "../../../components/common/table-component";

const Index = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', reportType: 0, reportValue: "north" });
	const [riskVehicleList, setRiskVehicleList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);

	useEffect(() => {
		loadData();

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword };
		const rsp = await dispatch(callGetExportRiskVehicleContract(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setRiskVehicleList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const downloadExcel = async () => {
		try {
			let data = { page: request.page, maxResult: totalRecord, keyword: request.keyword };
			let response = await callExportRiskVehicleContract(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text334", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("report.riskVehicle.name")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>

												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "report.riskVehicle.content.contractNumber", key: "contractNumber" },
							{ labelKey: "report.riskVehicle.content.total", key: "total", render: (val) => <span className="badge bg-danger">{val}</span> },
							{ labelKey: "report.riskVehicle.content.term", key: "term" },
							{ labelKey: "report.riskVehicle.content.nameLa", key: "nameLa", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.optionNameLa", key: "optionNameLa", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.packagePrice", key: "packagePrice", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.vehicleModel", key: "vehicleModel", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.licensePlate", key: "licensePlate", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.vehiclePower", key: "vehiclePower", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.engineNo", key: "engineNo", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.customerId", key: "customerId" },
							{ labelKey: "report.riskVehicle.content.firstName", key: "firstName", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.lastName", key: "lastName", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.agentCode", key: "agentCode" },
							{ labelKey: "report.riskVehicle.content.agentName", key: "agentName", style: { minWidth: '150px' } },
							{ labelKey: "report.riskVehicle.content.agentSurname", key: "agentSurname", style: { minWidth: '150px' } },
						]}
	data={{ result: riskVehicleList }}
	rowKey="contractNumber"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={true}
	rowNumberOffset={(request.page - 1) * request.maxResult}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
